import React, { Component } from 'react';

import parse, { domToReact, htmlToDOM } from 'html-react-parser';

import { InlineContentRenderer } from 'components/InlineContent/InlineContentRenderer';
import { withShareAttribs } from 'components/InlineContent/inlineShareAttribs';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AddFavorite from 'components/AddFavorite';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';
import getFeatureFlags from 'helpers/getFeatureFlags';
import { convertNbspEmptyLines } from 'helpers/convertNbspEmptyLines';
import DOMPurify from 'dompurify';
// import { renderToString } from 'react-dom/server';

const SpotifyPlayer = (props) => {
  const { links, width } = props;
  const parsedElements = [];

  links.forEach((link, i) => {
    const key = `${link}_${i}`;
    if (link.url.length > 0 && link.url.includes('spotify')) {
      parsedElements.push(<iframe key={key} title={link.url} src={link.url} height="500px" width={width} />);
    }
  });

  return parsedElements;
};

export default class TrainingText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
      user: {},
      lang: '',
    };
  }

  UNSAFE_componentWillMount() {
    StorageHandler.load(storageKeys.lang).then(({ langFile: lang }) => {
      this.setState({ lang });
    });
  }

  async componentDidMount() {
    const { appId, pageType } = this.props;
    const flags = await getFeatureFlags();
    const useEuServers = flags.eu_servers;
    let { text } = this.props;

    StorageHandler.load(storageKeys.user).then((userObj) => {
      const email = userObj && userObj.email ? userObj.email : 'Guest';
      if (pageType !== 'Final-Page') {
        const anaUri = useEuServers
          ? `https://eu.crm.travpromobile.com/api/uri?email=${email}&app_id=${appId}&url=`
          : `https://crm.travpromobile.com/api/uri?email=${email}&app_id=${appId}&url=`;
        text = text.replace('href="', `href="${anaUri}`);
        text = text.replace(
          /href="/g,
          ((i) => {
            return (m) => {
              return !i++ ? m : `href="${anaUri}`;
            };
          })(0),
        );
        text = text.replaceAll('<p> </p>', '<p><br/></p>');
        text = text.split('<a').join('<a target="_blank"');
        text = text.replaceAll('"zoom",', '');
      }
      this.setState({ text, user: userObj });

      // const weblinks = text.getElementsByTagName('a');
      // for (let i = 0, len = weblinks.length; i < len; i++) {
      //   weblinks[i].target = '_blank';
      // }
    });

    this.props.contentComplete?.();
  }

  render() {
    const { appId, buttons, badge, links, pageID, pageType, subtitle, title, type, upID, hideTitle, chapterTitle } =
      this.props;

    // const { text, user } = this.state;
    const { text } = this.state;

    // let chapterId = 0;
    // const index = upID.indexOf('P');
    // if (index !== -1) {
    //   chapterId = upID.substring(0, index);
    // }

    // const fancyOptions = {
    //   infobar: true,
    //   thumbs: {
    //     autoStart: true,
    //     axis: 'y',
    //   },
    //   buttons: ['share', 'close'],
    //   share: {
    //     tpl: renderToString(
    //       <SharingPopup
    //         url={`https://cms.travpromobile.com/api/app/diploma?first_name=${user.first_name}&last_name=${user.last_name}&app_id=chapter-${chapterId}`}
    //       />,
    //     ),
    //   },
    // };

    const sanitizeOptions = {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: [
        'allowfullscreen',
        'frameborder',
        'data-fancybox',
        'data-type',
        'data-options',
        'data-caption',
        'data-inline-idx',
        'rel',
      ],
      ALLOW_DATA_ATTR: false,
    };

    const inlineBlocks = [];

    // Empty lines are converted before &nbsp; becomes a regular space, which would otherwise collapse them to zero height.
    const decodedText = convertNbspEmptyLines(text.replace(/&lt;/g, '<').replace(/&gt;/g, '>')).replace(/&nbsp;/g, ' ');

    const processedText = decodedText
      .replace(/<strong>(?! )/g, '<strong> ')
      .replace(/allowTransparency="[a-zA-Z0-9:;.\s(),-]*"/gi, '')
      .replace(/allowfullscreen/gi, 'allowFullScreen="allowFullScreen"')
      .replace(/<inline>([\s\S]*?)<\/inline>/gi, (_match, inner) => {
        const idx = inlineBlocks.length;
        const safeInner = DOMPurify.sanitize(inner, sanitizeOptions);
        inlineBlocks.push(htmlToDOM(safeInner)); // nosemgrep -- safeInner is DOMPurify-sanitized
        return `<div data-inline-idx="${idx}"></div>`;
      });

    const textForParse = DOMPurify.sanitize(processedText, sanitizeOptions);

    return (
      <div className={`text__container ${pageType === 'Final-Page' ? 'wideFinalPage' : undefined}`} key={upID}>
        {/* <div className="text__container" key={upID}> */}
        {buttons}
        {(pageType === 'Final-Page' || pageType === 'Introduction') && <div className="image" />}
        {!hideTitle && (
          <h3
            className={`pageTitle ${
              pageType === 'Final-Page' && 'finalPageTitle'
            } ${title.length > 30 ? 'smallTitle' : ''}`}
          >
            {title}
          </h3>
        )}
        <h4>{subtitle}</h4>
        {type === 'Spotify' && <SpotifyPlayer links={links} width="100%" />}
        <div className="bodyContent">
          {parse(textForParse, {
            replace(domNode) {
              if (
                domNode.type === 'tag' &&
                domNode.name === 'div' &&
                domNode.attribs?.['data-inline-idx'] !== undefined
              ) {
                const idx = Number(domNode.attribs['data-inline-idx']);
                const parsedChildren = inlineBlocks[idx];
                if (!parsedChildren || parsedChildren.length === 0) return null;
                const fakeNode = { ...domNode, children: parsedChildren };
                return <InlineContentRenderer node={fakeNode} />;
              }
              if (domNode.type === 'tag' && domNode.name === 'a' && domNode.attribs?.['data-fancybox'] === '') {
                return <a {...withShareAttribs(domNode)}>{domToReact(domNode.children)}</a>;
              }
            },
          })}
        </div>
        {pageType === 'Final-Page' && badge && (
          <div className="trophy">
            <a
              className="trophy__button"
              href={`https://stack.travpromobile.com/download.php?url=${encodeURIComponent(
                badge,
              )}&name=${encodeURIComponent(chapterTitle)}`}
            >
              <FontAwesomeIcon icon={['fas', 'trophy']} />
              <span
                dangerouslySetInnerHTML={{
                  __html: i18n.translate('general.downloadBadge'),
                }}
              />
            </a>
          </div>
        )}
        {pageType !== 'Final-Page' && (
          <AddFavorite appId={Number(appId)} viewType="p" upID={upID} pageID={pageID} bgEnabled centered />
        )}
      </div>
    );
  }
}

TrainingText.propTypes = {
  buttons: PropTypes.oneOfType([PropTypes.object, PropTypes.element]),
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func,
  hideTitle: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.object),
  pageID: PropTypes.string,
  pageType: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  upID: PropTypes.string.isRequired,
  badge: PropTypes.string,
  chapterTitle: PropTypes.string,
};

TrainingText.defaultProps = {
  buttons: [],
  contentComplete: undefined,
  hideTitle: false,
  links: [],
  pageID: '',
  subtitle: '',
  text: '',
  title: '',
  type: '',
  badge: '',
  chapterTitle: '',
};
